import { Translation } from '@shared/types/translation';

export const CONTACT_REQUEST_MESSAGES = {
  VIEW_CR_SUCCESS_ASSIGNED: {
    english: 'Contact request assigned successfully.',
    polish: 'Zgłoszenie kontaktowe zostało przypisane.',
  },
  VIEW_CR_SUCCESS_REASSIGNED: {
    english: 'Contact request reassigned successfully.',
    polish: 'Zgłoszenie kontaktowe zostało pomyślnie przydzielone ponownie.',
  },
  VIEW_CR_SUCCESS_CANCELLED: {
    english: 'Contact request has been cancelled successfully.',
    polish: 'Zgłoszenie kontaktowe zostało anulowane.',
  },
} as const satisfies Record<string, Translation>;
